var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("" + (_vm.keyboardEnabled ? '' : 'full-height')),
      "customContentContainerStyles": {
        height: ("calc(100% - " + (_vm.isChromeOS ? 120 : _vm.isMobile ? 70 : 53) + "px)")
      }
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "mrs-news-syllables-container"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "chalkboard-text-container"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.fullWordDisplay)
    }
  })]), _c('img', {
    attrs: {
      "alt": "Chalkboard teacher image",
      "id": "chalkboard-teacher-image",
      "src": _vm.chalkBoardTeacherImage
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.syllablesLeft === 0,
      expression: "syllablesLeft === 0"
    }],
    class: {
      'selection-container': true,
      isMobile: _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "definitions-container"
  }, _vm._l(_vm.definitionActions, function (action, idx) {
    return _c('div', {
      key: idx,
      class: {
        'format-instructions-text': true,
        isMobile: _vm.isMobile
      },
      attrs: {
        "track-by": idx
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(((idx + 1) + ". "))
      }
    }), _c('span', {
      class: action.class
    }, [_vm._v(_vm._s(_vm._f("capitalize")(action.instruction)) + " ")]), _c('span', {
      domProps: {
        "textContent": _vm._s(action.text)
      }
    })]);
  }), 0), _c('div', {
    staticClass: "actions-container"
  }, [_c('TextFormattingButtons', {
    attrs: {
      "options": _vm.optionsTextFormattingButtons
    }
  }), _c('div', {
    staticClass: "solve-all-button-container",
    attrs: {
      "transition": _vm.innerTransition,
      "aria-live": "assertive",
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "solve-all-button pure-button",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.solveAllFormattings
    }
  }, [_c('span', [_vm._v("Solve All")])])])], 1), _c('div', {
    staticClass: "text-to-format-container"
  }, [_vm._l(_vm.definitionActions, function (word, idx) {
    return _c('div', {
      key: idx,
      class: {
        'text-to-format': true,
        isMobile: _vm.isMobile
      },
      attrs: {
        "id": word.id,
        "track-by": idx
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(word.text)
      },
      on: {
        "mousedown": _vm.enableSelection,
        "mouseleave": _vm.saveSelection
      }
    })]);
  }), _vm.activityErrorMsg ? _c('div', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "aria-live": "polite",
      "role": "alert"
    }
  }, [_c('red-x-solid-icon', {
    attrs: {
      "height": "26",
      "width": "27"
    }
  }), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.activityErrorMsg))])], 1) : _vm._e()], 2), _c('div', {
    staticClass: "facts-stage"
  }, _vm._l(_vm.factSteps, function (factStep, idx) {
    return _c('div', {
      key: idx,
      class: factStep.stepType,
      attrs: {
        "track-by": idx
      }
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text-step": idx + _vm.syllables.length + 1,
        "text": factStep.answer
      }
    })], 1);
  }), 0)])]), _c('ul', {
    staticClass: "right"
  }, _vm._l(_vm.syllables, function (syllable, idx) {
    return _c('li', {
      key: idx,
      attrs: {
        "track-by": idx
      }
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text-step": idx,
        "text": syllable.answer
      }
    })], 1);
  }), 0), _c('div', {
    attrs: {
      "id": "chalkboard"
    }
  })])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }